import * as React from 'react';
import { BookendsImageType, BookendsImageProps } from '../types';

export const Image = (
  props: BookendsImageType & React.ComponentProps<'div'> & BookendsImageProps
) => {
  const { className, image, ariaHidden, role = 'img', alt = `` } = props;
  const [isLoaded, setIsLoaded] = React.useState(false);

  if (!image) {
    return null;
  }

  if ('contents' in image) {
    return (
      <span
        className={className}
        dangerouslySetInnerHTML={{ __html: image.contents }}
      ></span>
    );
  } else {
    return (
      <img
        alt={alt}
        aria-hidden={ariaHidden}
        role={role}
        style={{
          opacity: isLoaded ? 1 : 0.1,
        }}
        src={image.url}
        className={className}
        width={image.width}
        height={image.height}
        loading={'lazy'}
        onLoad={() => setIsLoaded(true)}
      />
    );
  }
};
